import React from 'react'
import './App.css'
import {BrowserRouter, Route, Routes} from 'react-router-dom'
import Navbar from './Navbar.js'
import Home from './Home.js'
import Footer from './Footer.js'
import Progetti from './Progetti.js'
import Pr_Apice from './Pr_Apice.js'
import Pr_Tkinter from './Pr_Tkinter.js'
import Guida from './Guida.js'

const App = () => {
  return (
    <div>
        <BrowserRouter>
            <Navbar/>
            <Routes>
                <Route element={<Home/>} path={'/'} />
                <Route element={<Progetti/>} path={'/Progetti'} />
                <Route element={<Pr_Apice/>} path={'/Progetti/Apice'} />
                <Route element={<Pr_Tkinter/>} path={'/Progetti/Tkinter'} />
                <Route element={<Guida/>} path={'/Progetti/Tkinter/Guida'} />
            </Routes>
            <Footer/>
        </BrowserRouter>
    </div>
  )
}

export default App